import Instance from '../../../../Axios';

// New Actions for the app

const GetDocumentosOficiais = () => async (dispatch) => {
  await Instance()
    .get(`/energias/docsOficiais`)
    .then(({ data }) => {
      dispatch({ type: 'GET_DOCUMENTOS_OFICIAIS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetDocumentosOficiais;